import { FormValidateError, FormInitialState } from "../types/form";

const validate = (values: FormInitialState) => {
  const errors: FormValidateError = {};
  if (!values.id) {
    errors.id = "学籍番号を入力してください";
  } else if (!/^\d{7}$/i.test(values.id)) {
    errors.id = "学籍番号は数字7桁です";
  }

  if (!values.password) {
    errors.password = "パスワードを入力してください";
  }
  return errors;
};

export default validate;
